module.exports = __webpack_public_path__ + "img/electric_enabled.7cde2c43.svg";